import { Paragraph } from "@eworkit/iris";
import { FormikProps } from "formik";
import { isEmpty } from "lodash-es";
import React, { FC, memo } from "react";
import { Trans, useTranslation } from "react-i18next";
import * as Yup from "yup";

import { ErrorText } from "@/components/errors";
import { VALIDATION_TYPES } from "@/components/Formik";
import { Flex } from "@/eworkitComponents";
import { FormikCheckbox } from "@/formikComponents";
import { PublicAnchor } from "@/router/PublicAnchor";

import "./agreements.scss";

const baseClass = "agreements";
export const validationSchema = Yup.object()
  .required()
  .shape({
    agreements: Yup.object().shape({
      accessAgreement: Yup.boolean().test({ message: VALIDATION_TYPES.CHECKED, test: (value: boolean) => value }),
    }),
  });

export const AGREEMENTS_FORM_INIT_VALUES = {
  agreements: {
    accessAgreement: false,
  },
};

export interface IAgreementsFormValues {
  agreements: {
    accessAgreement: boolean;
  };
}

interface Props {
  form: FormikProps<IAgreementsFormValues>;
}

export const AgreementsForm: FC<Props> = memo(({ form }) => {
  const { t } = useTranslation("public");

  return (
    <Flex direction="column" innerMargin="xs" padding={[false, false, "lg", false]}>
      <FormikCheckbox name="agreements.accessAgreement" required checked={form.values.agreements.accessAgreement}>
        <Trans ns="public" i18nKey="SESSION_SIGNUP.USER_FORM.CHECKBOX_USER_AGREEMENT">
          <PublicAnchor page="PRIVACY-POLICY" target="_blank" className={`${baseClass}`} />
          <PublicAnchor page="USER-ACCESS-AGREEMENT" target="_blank" className={`${baseClass}`} />
        </Trans>
        <Paragraph color="r500"> *</Paragraph>
      </FormikCheckbox>

      {!isEmpty(form.errors.agreements) && <ErrorText error={t("SESSION_SIGNUP.USER_FORM.AGREEMENTS_ERROR")} />}
    </Flex>
  );
});
